module.exports = __webpack_public_path__ + "static/media/PM70.52d80f72.JPG";